<div class="bd-header">
  <div class="d-md-flex justify-content-between container-title-repository" [class.flex-md-row-reverse] = "urlRepository">
    <app-link-repository *ngIf="urlRepository" [urlRepository]="urlRepository" [headerBDC]="false"></app-link-repository>
    <div class="title">
      <span class="title-position" [id]="idTitle">&nbsp;</span>
      <h2 class="m-0">{{title}}</h2>
    </div>
  </div>
  <p class="text-1" style="text-align: justify;" [innerHTML]="description"></p>
  <div class="container-entities" *ngIf="entities.length > 0">
    <div class="container-title-entities d-md-flex justify-content-between">
      <h6 class="m-0">Requerido, mínimamente, en:</h6>
    </div>
    <div  class="container-entitie">
      <ng-container *ngFor="let entitie of entitiesList">
        <a class="text-1" *ngIf="exist(entitie.name)" href="{{entitie.url}}" rel="noopener" target="_blank">{{entitie.name}}</a>
      </ng-container>
    </div>
  </div>
  <hr class="hr-divider">
</div>
